import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert, MenuItem,
} from '@mui/material';

const ChangeOrderDialog = ({ open, onClose, newChangeOrder, onNewChangeOrderChange, onSubmit, isMobile }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={isMobile}>
    <DialogTitle>Add Change Order</DialogTitle>
    <DialogContent>
      <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
        This change order will be linked to the original item and will be included in the total project budget.
      </Alert>
      <TextField
        margin="dense"
        label="Change Order Title"
        fullWidth
        variant="outlined"
        value={newChangeOrder.title}
        onChange={(e) => onNewChangeOrderChange({ ...newChangeOrder, title: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        select
        margin="dense"
        label="Type"
        fullWidth
        variant="outlined"
        value={newChangeOrder.type}
        onChange={(e) => onNewChangeOrderChange({ ...newChangeOrder, type: e.target.value })}
        sx={{ mb: 2 }}
      >
        <MenuItem value="labor">Labor</MenuItem>
        <MenuItem value="materials">Materials</MenuItem>
        <MenuItem value="both">Materials and Labor</MenuItem>
      </TextField>
      <TextField
        margin="dense"
        label="Cost"
        fullWidth
        variant="outlined"
        type="number"
        value={newChangeOrder.cost}
        onChange={(e) => onNewChangeOrderChange({ ...newChangeOrder, cost: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        margin="dense"
        label="Image URL (Optional)"
        fullWidth
        variant="outlined"
        value={newChangeOrder.image_url}
        onChange={(e) => onNewChangeOrderChange({ ...newChangeOrder, image_url: e.target.value })}
        sx={{ mb: 2 }}
      />
      <TextField
        margin="dense"
        label="Approval Deadline (Optional)"
        fullWidth
        variant="outlined"
        type="datetime-local"
        value={newChangeOrder.approval_deadline || ''}
        onChange={(e) => onNewChangeOrderChange({ ...newChangeOrder, approval_deadline: e.target.value })}
        InputLabelProps={{ shrink: true }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        disabled={!newChangeOrder.title.trim() || !newChangeOrder.cost}
      >
        Create Change Order
      </Button>
    </DialogActions>
  </Dialog>
);

export default ChangeOrderDialog;
